import {
  IconFinancePercent16,
  IconFunctionalCalendar16,
  IconFunctionalHouse16,
  IconInfrastructureResting16,
  IconMapPin16,
  IconPlaceholderBuilder16,
  IconProductApartmentPlan16,
} from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

export interface ITitleIconProps {
  icon?: string | null;
}

export const TitleIcon = ({ icon }: ITitleIconProps) => {
  switch (icon) {
    case 'IconFunctionalCalendar16':
      return <IconFunctionalCalendar16 color="accent-main-primary" />;

    case 'IconProductApartmentPlan16':
      return <IconProductApartmentPlan16 color="accent-main-primary" />;

    case 'IconPlaceholderBuilder16':
      return <IconPlaceholderBuilder16 color="accent-main-primary" />;

    case 'IconFunctionalHouse16':
      return <IconFunctionalHouse16 color="accent-main-primary" />;

    case 'IconMapPin16':
      return <IconMapPin16 color="accent-main-primary" />;

    case 'IconInfrastructureResting16':
      return <IconInfrastructureResting16 color="accent-main-primary" />;

    case 'IconFinancePercent16':
      return <IconFinancePercent16 color="accent-main-primary" />;

    default:
      return null;
  }
};
